import { render, staticRenderFns } from "./ListRequestLetterTaghirModatSepordeh.vue?vue&type=template&id=3b251516&scoped=true&"
import script from "./ListRequestLetterTaghirModatSepordeh.vue?vue&type=script&lang=js&"
export * from "./ListRequestLetterTaghirModatSepordeh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b251516",
  null
  
)

export default component.exports